export default __webpack_public_path__ + "static/media/intro-1.d04649be.jpg";